import { render, staticRenderFns } from "./SkinViewer.vue?vue&type=template&id=4f12b8a9&scoped=true&"
import script from "./SkinViewer.vue?vue&type=script&lang=js&"
export * from "./SkinViewer.vue?vue&type=script&lang=js&"
import style0 from "./SkinViewer.vue?vue&type=style&index=0&id=4f12b8a9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f12b8a9",
  null
  
)

export default component.exports